import * as angular from 'angular';

import CoreModule from '../core/core.module';

import BenchmarkGraphService from './benchmarkGraph.service';
import BenchmarkGraphConfigService from './benchmarkGraphConfig.service';
import {
  GraphsBenchmarksGraphController,
  BenchmarksGraphDirective
} from './benchmarksGraph.directive';
import {
  GraphsHighchartController,
  HighchartDirective
} from './highchart.directive';
import RoundCurrencyFilter from './roundCurrency.filter';
import SpendGraphHtmlDirective from './spendGraphHtml.directive';

import '../../../sass/graphs.scss';

/** Graphs module
 *
 * Also include graphs.css
 */
export default angular
  .module('graphs', [CoreModule])
  .service('BenchmarkGraph', BenchmarkGraphService)
  .service('BenchmarkGraphConfig', BenchmarkGraphConfigService)
  .controller(
    'GraphsBenchmarksGraphController',
    GraphsBenchmarksGraphController
  )
  .directive('benchmarksGraph', BenchmarksGraphDirective)
  .controller('GraphsHighchartController', GraphsHighchartController)
  .directive('highchart', HighchartDirective)
  .filter('roundCurrency', RoundCurrencyFilter)
  .directive('spendGraphHtml', SpendGraphHtmlDirective).name;
